module.exports = {
    TAB_CARD_INFO: 1,
    TAB_INSTANT_POPUP: 2,
    TAB_AUTO_RECHARGE: 3,
    TAB_USAGE_HISTORY: 4,
    TAB_INVOICE_HISTORY: 5,
    TAB_AUTO_RECHARGE_WITH_ACTIVATION: 6
}